import { Button, Dropdown } from 'react-bootstrap';
import { FaUser, FaSignOutAlt, FaCog, FaUserCircle, FaArrowsAltH } from 'react-icons/fa';
import { useKeycloak } from '../context/KeycloakContext';
import Config from '../config/Config';
import DppDropdownMenu from '../components/DppDropdownMenu';
import { FormattedMessage } from 'react-intl';

const UserSection = ({ toggleLanguage, currentLanguage }) => {
  const { mainColor } = Config.appearance;
  
  // Access Keycloak methods via the useKeycloak hook
  const { isAuthenticated, logout, getUsername, hasRole } = useKeycloak();

  // Base items for the dropdown menu
  const menuItems = [
    // Profile and sign out
    {
      label: <FormattedMessage id="profile" />,
      icon: FaUserCircle,
      action: undefined,
      link: '/profile', // Link to profile page
    },
    {
      label: <FormattedMessage id="sign_out" />,
      icon: FaSignOutAlt,
      action: () => logout(), // Call logout when clicked
    },
  ];

  // Base items for the dropdown menu specifically for demo
  const menuItemsDemo = [
    // Profile and sign out
    {
      label: <FormattedMessage id="profile" />,
      icon: FaUserCircle,
      action: undefined,
      link: '/profile', // Link to profile page
    }
  ];

  // Conditionally add admin-related items if the user has the 'admin' role
  if (isAuthenticated() && hasRole('admin')) {
    // access-control item
    const accessControlItem = {
      label: <FormattedMessage id="access_control" />,
      icon: FaArrowsAltH,
      action: undefined,
      link: '/access-control', // Link to admin page
    };

    // Add a divider between admin and other sections
    menuItems.push({ type: 'divider' });
    menuItemsDemo.push({ type: 'divider' });

    // Admin-related items
    menuItems.push(accessControlItem);
    menuItemsDemo.push(accessControlItem);
  }

  // Function to handle item selection
  const handleSelect = (action) => {
    action(); // Call the action passed from the menu items
  };

  return (
    <div className="d-flex align-items-center">
      {!isAuthenticated() ? (
        <Button
          onClick={() => window.location.reload()}
          style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: mainColor,
              display: 'flex',
              alignItems: 'center',
            }}
        >
          <FormattedMessage id="login" />
        </Button>
      ) : (
        <Dropdown>
          <Dropdown.Toggle
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: mainColor,
              display: 'flex',
              alignItems: 'center',
            }}
            id="dropdown-basic"
          >
            <FaUser style={{ marginRight: '10px', color: mainColor, fontSize: '18px' }} />
            {getUsername()}
          </Dropdown.Toggle>

          {/* Use the reusable DropdownMenu */}
          <DppDropdownMenu items={Config.isDemo === 'true' ? menuItemsDemo : menuItems} onSelect={handleSelect} />
        </Dropdown>
      )}

      {/* Vertical Divider */}
      <div style={{
        borderLeft: `1px solid ${mainColor}`,
        height: '20px', // Adjust this based on your layout
        margin: '0 5px',
      }} />

      {/* Single Language Toggle Button */}
      <Button
        onClick={() => toggleLanguage(currentLanguage === 'en' ? 'de' : 'en')}
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          width: '44px',
          color: mainColor,
          alignItems: 'center',
        }}
      >
        {currentLanguage === 'en' ? 'EN' : 'DE'}
      </Button>
    </div>
  );
};

export default UserSection;
